import { BehaviorSubject } from 'rxjs';

export const behaviorCatalogueNavigation$ = new BehaviorSubject({});

export const behaviorCatalogueNavigation = behaviorCatalogueNavigation$.asObservable();
